import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import PlayerStatsTable from '../components/PlayerStatsTable';
import { API_ENDPOINTS } from '../config/api';

const SeasonGeneralStatsPage = () => {
    return (
        <Container maxWidth="xl">
            <Box sx={{ my: 4 }}>
                <PlayerStatsTable apiUrl={API_ENDPOINTS.PLAYER_STATS} />
            </Box>
        </Container>
    );
};

export default SeasonGeneralStatsPage; 